/**
 * Lightstone's toolkit is South African deeds only. Keep this in sync with
 * api/_lib/lightstoneCoverage.js.
 */
const US_STATE_ZIP = /\b(AL|AK|AZ|AR|CA|CO|CT|DC|DE|FL|GA|HI|IA|ID|IL|IN|KS|KY|LA|MA|MD|ME|MI|MN|MO|MS|MT|NC|ND|NE|NH|NJ|NM|NV|NY|OH|OK|OR|PA|RI|SC|SD|TN|TX|UT|VA|VT|WA|WI|WV|WY)\s+\d{5}(?:-\d{4})?\b/;
const NON_SA_COUNTRY = /\b(united states|u\.s\.a\.|usa|canada|united kingdom|england|scotland|wales|australia|new zealand|germany|france|netherlands|belgium|dubai|united arab emirates|uae)\b/i;

export function lightstoneCoverageRejectReason(address) {
    const q = String(address || '').trim();
    if (!q) return '';
    if (US_STATE_ZIP.test(q) || NON_SA_COUNTRY.test(q)) {
        return 'Property reports only cover South African deeds. This address looks like it is outside South Africa — pick an SA property, or use the manual upload if you already have a report.';
    }
    return '';
}

export function isOutsideLightstoneCoverage(address) {
    return Boolean(lightstoneCoverageRejectReason(address));
}
